import { render, staticRenderFns } from "./ClaimFormTab.vue?vue&type=template&id=0d0faeb0"
import script from "./ClaimFormTab.vue?vue&type=script&lang=js"
export * from "./ClaimFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports